'use client';

import { cn } from '@core/utils';

import { AD_PLACEMENTS } from './adPlacements';
import { BannerAdSlot } from './BannerAdSlot';

interface SearchSideAdBannerProps {
  className?: string;
}

//* 광고가 없으면 BannerAdSlot이 null을 반환해 우측 칼럼이 접힌다.
export const SearchSideAdBanner = ({ className }: SearchSideAdBannerProps) => (
  <BannerAdSlot
    {...AD_PLACEMENTS.searchSide}
    wrapperClassName={cn('hidden w-250 shrink-0 xl:block', className)}
  />
);
